<template>
  <div class="no-data">
    <img src="@/assets/images/no-data.png" alt="">
    <div v-if="!noTxt" class="ml-20 color-666">
      <p>抱歉，没有找到相关结果。建议：</p>
      <p>1、请您尝试简化输入词</p>
      <p>2、请您尝试减少筛选条件</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noTxt: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-data{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    //padding: 150px 0;
    img{
      width: 320px;
    }
  }
</style>
